/**
 * Recessive axes: 1 px gridlines in --color-border, compact tick labels in text tokens. Owner: slice web-charts (#1115).
 */
import { INK } from './chart-theme'

export function YGrid({
  ticks,
  y,
  left,
  right,
  format,
}: {
  ticks: number[]
  y: (v: number) => number
  left: number
  right: number
  format: (n: number) => string
}) {
  return (
    <g>
      {ticks.map((t) => (
        <g key={t}>
          <line
            x1={left}
            x2={right}
            y1={Math.round(y(t)) + 0.5}
            y2={Math.round(y(t)) + 0.5}
            stroke={t === 0 ? 'var(--color-border-strong)' : INK.grid}
            strokeWidth={1}
          />
          <text x={left - 6} y={y(t)} dy="0.32em" textAnchor="end" fontSize={11} fill={INK.secondary} className="tabular">
            {format(t)}
          </text>
        </g>
      ))}
    </g>
  )
}

export function XLabels({ labels, xAt, y, every }: { labels: string[]; xAt: (i: number) => number; y: number; every: number }) {
  return (
    <g>
      {labels.map((l, i) =>
        i % every === 0 ? (
          // biome-ignore lint/suspicious/noArrayIndexKey: labels can repeat (two buckets with the same display label)
          <text key={i} x={xAt(i)} y={y} textAnchor="middle" fontSize={11} fill={INK.secondary}>
            {l}
          </text>
        ) : null,
      )}
    </g>
  )
}
